import { encodeActivity } from 'modules/core/lib/activities/utils'
import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const FillFormTaskDefinition: TaskDefinition<'FormsMyMembership'> = {
  taskableTypename: 'FormsMyMembership',
  initialState: {},
  getUrl: ({ info, status }) => {
    const formId = info.materializedForm?.surveyForm?.id || info.materializedForm?.trainingForm?.id
    const resourceType =
      info.materializedForm?.trainingForm?.resourceType ?? info.materializedForm?.resourceType
    const membershipId = info.stringId

    const materializedFormResourceType = info.materializedForm?.resourceType ?? ''

    const isCompleted = status === 'done'

    if (!membershipId || !formId || !resourceType) return null

    if (isCompleted) {
      if (!materializedFormResourceType) return null

      return `#${encodeActivity('forms.formResponses', {
        formId,
        membershipId,
        resourceType,
        materializedFormResourceType,
      })}`
    }

    return `#${encodeActivity('forms.answerForm', {
      formId,
      membershipId,
      resourceType,
    })}`
  },
  getTitle: ({ info, affecteeName }) => {
    const surveyName = info.materializedForm?.formTitle

    if (affecteeName && affecteeName.length > 1) {
      return i18n.t('tasks.inbox.titles.survey_affectee', {
        surveyName,
        affecteeName,
      })
    }

    return i18n.t('tasks.inbox.titles.survey_own', {
      surveyName,
    })
  },
  getMetadata: ({ info }) => {
    const resourceType = info.materializedForm?.resourceType
    const trainingName = info.materializedForm?.resourceFormName

    if (resourceType === 'Trainings::TrainingClass' && trainingName) {
      return [trainingName]
    }

    return []
  },
}
